/**
 * Application configuration
 * Handles environment-specific settings with smart defaults
 */

/**
 * Get the backend API URL based on the current environment
 * @returns {string} The backend URL
 */
export const getBackendUrl = () => {
  // CRITICAL FIX: Always prioritize dynamic detection over hardcoded env vars
  // This prevents preview URLs from leaking into production
  
  // 1. First, detect current environment from hostname
  const currentHost = window.location.hostname;
  const currentProtocol = window.location.protocol;
  
  // 2. Production domains - ALWAYS use current domain for API
  if (currentHost === 'medurgence.com' || 
      currentHost === 'urgencemed.com' ||
      currentHost.includes('medurgence') || 
      currentHost.includes('urgencemed')) {
    console.log('🟢 Production detected:', currentHost);
    return `${currentProtocol}//${currentHost}`;
  }
  
  // 3. Preview/staging domains - use current domain
  if (currentHost.includes('.preview.') || 
      currentHost.includes('.emergentagent.com') ||
      currentHost.includes('doctools-13')) {
    console.log('🟡 Preview/Staging detected:', currentHost);
    return `${currentProtocol}//${currentHost}`;
  }
  
  // 4. Local development - check env var, otherwise use localhost
  if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
    const envUrl = process.env.REACT_APP_BACKEND_URL;
    if (envUrl && !envUrl.includes('.preview.') && !envUrl.includes('doctools')) {
      console.log('🔵 Local with env URL:', envUrl);
      return envUrl;
    }
    console.log('🔵 Local development: localhost:8001');
    return 'http://localhost:8001';
  }
  
  // 5. Fallback - use current domain (safest option)
  console.warn('⚠️ Unknown environment, using current domain:', currentHost);
  return `${currentProtocol}//${currentHost}`;
};

export const API_URL = getBackendUrl();

// Log the configuration in development
if (process.env.NODE_ENV === 'development') {
  console.log('📡 Backend API URL:', API_URL);
}
